import React, { useState } from 'react';
import GasCostCalculator from './GasCostCalculator';
import EvCostCalculator from './EVCostCalculator';
import './CostCalculator.css'; // Ensure this import is present

const CostCalculator = () => {
  const [activeTab, setActiveTab] = useState('gas');

  const renderContent = () => {
    if (activeTab === 'gas') {
      return <GasCostCalculator />;
    } else if (activeTab === 'ev') {
      return <EvCostCalculator />;
    }
  };

  return (
    <div className="cost-calculator">
      <div className="tabs">
        <button
          className={`tab-button ${activeTab === 'gas' ? 'active' : ''}`}
          onClick={() => setActiveTab('gas')}
        >
          Gas Calculator
        </button>
        <button
          className={`tab-button ${activeTab === 'ev' ? 'active' : ''}`}
          onClick={() => setActiveTab('ev')}
        >
          EV Calculator
        </button>
      </div>
     {/* <h1>{activeTab === 'gas' ? 'Gas Cost Calculator' : 'EV Cost Calculator'}</h1> */}
      {renderContent()}
    </div>
  );
};

export default CostCalculator;